function NRReachableComponentIcon({ height = '24', width = '24', color = 'currentcolor' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <g transform="translate(2, 2)">
        <path
          d="M12.1502 5.9013L13.3335 7.08464L10.0002 10.418L6.66683 7.08464L7.85016 5.9013L9.17516 7.2263V2.08464L10.0002 1.66797L10.8252 2.08464V7.2263L12.1502 5.9013Z"
          fill={color}
        />
        <path
          d="M10.0002 15.0013L0.833496 10.0013L6.66683 8.71643L4.31266 10.0013L10.0002 13.1055L15.6877 10.0013L13.3335 8.71643L19.1668 10.0013L10.0002 15.0013Z"
          fill={color}
        />
        <path d="M10.0002 18.3346L1.31266 13.6055L3.06266 12.6471L10.0002 16.4388L16.9377 12.6471L18.6877 13.6055L10.0002 18.3346Z" fill={color} />
      </g>
    </svg>
  );
}
export default NRReachableComponentIcon;
